import { getElementOrLogError } from '../../utils/utils';
export class ModalWindow {
    constructor(container, events) {
        this.events = events;
        this.container = container;
        this.closeButton = getElementOrLogError('.modal__close', container);
        this.content = getElementOrLogError('.modal__content', container);
        this.wrapper = getElementOrLogError('.page__wrapper', document.body);
        this.initializeEventListeners();
    }
    initializeEventListeners() {
        this.closeButton.addEventListener('click', () => this.hide());
        this.container.addEventListener('click', () => this.hide());
        const modalContent = getElementOrLogError('.modal__container', this.container);
        modalContent.addEventListener('click', (event) => event.stopPropagation());
    }
    setContent(content) {
        this.content.replaceChildren(content);
    }
    show() {
        this.container.classList.add('modal_active');
        this.events.emit('modal:open');
    }
    hide() {
        this.container.classList.remove('modal_active');
        this.clearContent();
        this.events.emit('modal:close');
    }
    clearContent() {
        this.content.innerHTML = '';
    }
    set isLocked(locked) {
        this.wrapper.classList.toggle('page__wrapper_locked', locked);
    }
    render() {
        this.show();
        return this.container;
    }
}
